import { render, staticRenderFns } from "./TicketOperate.vue?vue&type=template&id=24dc1ac3&scoped=true&"
import script from "./TicketOperate.vue?vue&type=script&lang=js&"
export * from "./TicketOperate.vue?vue&type=script&lang=js&"
import style0 from "./TicketOperate.vue?vue&type=style&index=0&id=24dc1ac3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc1ac3",
  null
  
)

export default component.exports